export enum WISCreateModalQueryString {
  IsOpen = 'wis',
  IsRerun = 'rerun'
}
